// Hızlı tarih aralığı ön ayarları (bugün, dün, bu hafta, geçen hafta, bu ay,
// geçen ay). Tarihler yerel saate göre "YYYY-MM-DD" string olarak döner; bu
// format <input type="date"> alanlarıyla birebir uyumludur. Hafta Pazartesi
// başlangıçlı kabul edilir.

function toYMD(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export const DATE_RANGE_PRESETS = [
  { key: "today", label: "Bugün" },
  { key: "yesterday", label: "Dün" },
  { key: "thisWeek", label: "Bu Hafta" },
  { key: "lastWeek", label: "Geçen Hafta" },
  { key: "thisMonth", label: "Bu Ay" },
  { key: "lastMonth", label: "Geçen Ay" },
];

// key -> { start: "YYYY-MM-DD", end: "YYYY-MM-DD" }
export function getDateRangePreset(key) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let start = new Date(today);
  let end = new Date(today);

  switch (key) {
    case "today":
      break;
    case "yesterday":
      start.setDate(start.getDate() - 1);
      end.setDate(end.getDate() - 1);
      break;
    case "thisWeek": {
      // Pazartesi başlangıçlı haftanın başı -> bugün
      const offset = (today.getDay() + 6) % 7;
      start.setDate(start.getDate() - offset);
      break;
    }
    case "lastWeek": {
      const offset = (today.getDay() + 6) % 7;
      const thisMonday = new Date(today);
      thisMonday.setDate(thisMonday.getDate() - offset);
      start = new Date(thisMonday);
      start.setDate(start.getDate() - 7); // geçen haftanın Pazartesi'si
      end = new Date(thisMonday);
      end.setDate(end.getDate() - 1); // geçen haftanın Pazar'ı
      break;
    }
    case "thisMonth":
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      break;
    case "lastMonth":
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0); // geçen ayın son günü
      break;
    default:
      break;
  }

  return { start: toYMD(start), end: toYMD(end) };
}
